import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./fonts/icomoon/style.css";
import "./css/bootstrap.min.css";
import "./css/bootstrap-datepicker.css";
import "./css/jquery.fancybox.min.css";
import "./css/owl.carousel.min.css";
import "./css/owl.theme.default.min.css";
import "./fonts/flaticon/font/flaticon.css";
import "./css/style.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
